import { useState, useEffect, useCallback } from 'react';
import { employeeSalaryConfigService } from '../services/employeeSalaryConfigService';
import { getDateNow } from '../../utils/textUtils';

export function useEmployeeSalaryConfig({
  employeePersonalInformationId,
  showGeneralMessage,
  isMainModule = true, // Default to true for main module usage
}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    if (!employeePersonalInformationId) return;

    setLoading(true);
    try {

      const payload = {
        effectiveDate: getDateNow()
      }
      const result = await employeeSalaryConfigService.getData(employeePersonalInformationId, payload);
      setData(result);
    } catch (error) {
      const errorMsg = error.response?.data?.message || "Failed to fetch employee salary configuration";
      showGeneralMessage(errorMsg, false);
      console.error(errorMsg, error);
    } finally {
      setLoading(false);
    }
  }, [employeePersonalInformationId, showGeneralMessage]);

  useEffect(() => {
    if (!isMainModule) return; // Only auto fetch data if it's the main module
    fetchData();
  }, [fetchData, isMainModule]);

  return {
    data,
    loading,
    refresh: fetchData
  };
}